import { useMutation } from 'react-query';
import {
  performanceReportingApiUrl,
  fetcher,
  handleError,
  ServerErrorResponse,
} from 'data_sources/constants';
import type { UpdateEisFlagRequest } from '../_types';

export const updateEisFlag = async (
  flagId: string | number,
  data: UpdateEisFlagRequest,
  onError?: (errors: ServerErrorResponse) => void
): Promise<void> => {
  const url = `${performanceReportingApiUrl()}/performance/eis/v1/flags/${flagId}`;
  await fetcher({
    url,
    method: 'PATCH',
    body: data,
  })
    .then((response) => {
      if (response?.errorDetails) {
        if (onError) onError(response);
      }
    })
    .catch((err) => {
      if (onError) handleError(err, { onError });
    });
};

export default function useUpdateEisFlag() {
  return useMutation(
    ({ flagId, data }: { flagId: string | number; data: UpdateEisFlagRequest }) =>
      updateEisFlag(flagId, data)
  );
}
